module.exports = __webpack_public_path__ + "static/approved_rejected.86eccdbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/membership/approved_rejected.png
// module id = 713
// module chunks = 92562407457355